var ProvincialCityService = /** @class */ (function () {
    function ProvincialCityService() {
        this.provinces = ["Eastern Cape", "Free State", "Gauteng", "KwaZulu-Natal", "Limpopo",
            "Mpumalanga", "North West", "Northern Cape", "Western Cape"];
        this.cities = {
            Gauteng: ["City Of Johannesburg", "City Of Tshwane", "Ekurhuleni", "Metsweding District", "Sedibeng District", "West Rand District"]
        };
    }
    ProvincialCityService.getInstance = function () {
        if (!ProvincialCityService.instance) {
            ProvincialCityService.instance = new ProvincialCityService();
        }
        return ProvincialCityService.instance;
    };
    ProvincialCityService.prototype.getProvices = function () {
        var jsonProvinces = [];
        this.provinces.forEach(function (item) {
            var province = {};
            province["name"] = item;
            province["value"] = item.replace(/\s/g, "_");
            jsonProvinces.push(province);
        });
        var output = [];
        output["provinces"] = jsonProvinces;
        return output;
    };
    ProvincialCityService.prototype.getCities = function (provinceValue) {
        var output = [];
        if (provinceValue) {
            var provinceCities = this.cities[provinceValue];
            var jsonCities_1 = [];
            if (provinceCities) {
                provinceCities.forEach(function (item) {
                    var city = {};
                    city["name"] = item;
                    city["value"] = item.replace(/\s/g, "");
                    jsonCities_1.push(city);
                });
                output["cities"] = jsonCities_1;
                return output;
            }
        }
    };
    return ProvincialCityService;
}());
export { ProvincialCityService };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/sa-provincial-city/sa-provincial-city.service.ts
// module id = 14
// module chunks = 0